"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _BarChart = _interopRequireDefault(require("./components/BarChart"));
var _ApplicationDetailsModal = _interopRequireDefault(require("./components/ApplicationDetailsModal"));
var _vuex = require("vuex");
var _application = require("@/services/application.service");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'Applications',
  components: {
    Page: _Page.default,
    BarChart: _BarChart.default,
    ApplicationDetailsModal: _ApplicationDetailsModal.default
  },
  data: function data() {
    var _this = this;
    return {
      dashboardData: {
        lotes: 0,
        setores: 0,
        aplicacoesPendentes: 0,
        aplicacoesAtraso: 0
      },
      applications: [],
      filteredApplications: [],
      isLoadingFiltered: false,
      selectedApplication: null,
      showApplicationModal: false,
      pagination: {
        currentPage: 1,
        hasMore: true,
        loading: false,
        totalCount: 0
      },
      filters: {
        categoriasSelecionadas: '',
        setoresSelecionados: '',
        startDate: (0, _moment.default)().startOf('year').toDate(),
        endDate: (0, _moment.default)().endOf('year').toDate(),
        quickFilter: '1y'
      },
      quickFilters: [{
        label: 'Últimos 7 dias',
        value: '7d'
      }, {
        label: 'Últimos 30 dias',
        value: '30d'
      }, {
        label: 'Últimos 3 meses',
        value: '3m'
      }, {
        label: 'Último ano',
        value: '1y'
      }, {
        label: 'Personalizado',
        value: 'custom'
      }],
      categorias: [{
        label: 'Fungicida',
        value: 'FUNGICIDE'
      }, {
        label: 'Inseticida',
        value: 'INSECTICIDE'
      }, {
        label: 'Herbicida',
        value: 'HERBICIDE'
      }, {
        label: 'Fungicida e Inseticida',
        value: 'FUNGICIDE_INSECTICIDE'
      }],
      setores: [],
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1
            }
          }],
          xAxes: [{
            ticks: {
              callback: function callback(value, index) {
                var _this$chartData$datas;
                var monthlyData = ((_this$chartData$datas = _this.chartData.datasets[0]) === null || _this$chartData$datas === void 0 ? void 0 : _this$chartData$datas.data) || [];
                var count = monthlyData[index] || 0;
                return [value, count.toString()];
              }
            }
          }]
        },
        legend: {
          display: false
        },
        title: {
          display: true,
          text: 'Aplicações por Mês'
        },
        tooltips: {
          callbacks: {
            label: function label(tooltipItem) {
              return "Aplica\xE7\xF5es: ".concat(tooltipItem.yLabel);
            }
          }
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    menuItems: 'menuItemsApplications',
    isLoading: 'isLoading',
    farm: 'GET_FARM',
    user: 'userAdmin'
  })), {}, {
    totalAno: function totalAno() {
      return this.filteredApplications.length;
    },
    filteredPendingApplications: function filteredPendingApplications() {
      var today = (0, _moment.default)().startOf('day');
      var sevenDaysFromNow = (0, _moment.default)().add(7, 'days').startOf('day');
      return this.filteredApplications.filter(function (app) {
        var appDate = (0, _moment.default)(app.dataAplicacao).startOf('day');
        var isActive = app.status !== 'FINISHED';
        return isActive && appDate.isSameOrAfter(today) && appDate.isSameOrBefore(sevenDaysFromNow);
      }).length;
    },
    filteredOverdueApplications: function filteredOverdueApplications() {
      var today = (0, _moment.default)().startOf('day');
      return this.filteredApplications.filter(function (app) {
        var appDate = (0, _moment.default)(app.dataAplicacao).startOf('day');
        return app.status !== 'FINISHED' && appDate.isBefore(today);
      }).length;
    }
  }),
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return this.loadSetores();
          case 1:
            _context.n = 2;
            return this.loadDashboardData();
          case 2:
            _context.n = 3;
            return this.loadApplications();
          case 3:
            this.updateChartData();
          case 4:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    loadDashboardData: function () {
      var _loadDashboardData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$applicationSer, countsResponse, _yield$applicationSer2, activeApplications, today, sevenDaysFromNow, pendentes, atrasadas, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return _application.applicationService.fetchFarmCounts(this.farm.id);
            case 1:
              _yield$applicationSer = _context2.v;
              countsResponse = _yield$applicationSer.data;
              this.dashboardData.lotes = countsResponse.lotsCount || 0;
              this.dashboardData.setores = countsResponse.sectorsCount || 0;
              _context2.n = 2;
              return _application.applicationService.fetchActiveApplications(this.farm.id);
            case 2:
              _yield$applicationSer2 = _context2.v;
              activeApplications = _yield$applicationSer2.data;
              if (Array.isArray(activeApplications)) {
                today = (0, _moment.default)().startOf('day');
                sevenDaysFromNow = (0, _moment.default)().add(7, 'days').startOf('day');
                pendentes = activeApplications.filter(function (app) {
                  var appDate = (0, _moment.default)(app.applicationDate).startOf('day');
                  return appDate.isSameOrAfter(today) && appDate.isSameOrBefore(sevenDaysFromNow);
                });
                this.dashboardData.aplicacoesPendentes = pendentes.length;
                atrasadas = activeApplications.filter(function (app) {
                  var appDate = (0, _moment.default)(app.applicationDate).startOf('day');
                  return appDate.isBefore(today);
                });
                this.dashboardData.aplicacoesAtraso = atrasadas.length;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.error('Erro ao carregar dados do dashboard:', _t);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 3]]);
      }));
      function loadDashboardData() {
        return _loadDashboardData.apply(this, arguments);
      }
      return loadDashboardData;
    }(),
    loadSetores: function () {
      var _loadSetores = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$applicationSer3, data, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return _application.applicationService.fetchSectorsDropdown(this.farm.id);
            case 1:
              _yield$applicationSer3 = _context3.v;
              data = _yield$applicationSer3.data;
              this.setores = data || [];
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              console.error('Erro ao carregar setores:', _t2);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function loadSetores() {
        return _loadSetores.apply(this, arguments);
      }
      return loadSetores;
    }(),
    loadApplications: function () {
      var _loadApplications = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var reset,
          _response$data,
          params,
          _yield$applicationSer4,
          response,
          responseData,
          newApplications,
          _this$applications,
          meta,
          _args4 = arguments,
          _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              reset = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : true;
              _context4.p = 1;
              if (reset) {
                this.pagination.currentPage = 1;
                this.applications = [];
                this.filteredApplications = [];
                this.isLoadingFiltered = true;
              }
              params = {
                startDate: (0, _moment.default)(this.filters.startDate).format('YYYY-MM-DD'),
                endDate: (0, _moment.default)(this.filters.endDate).format('YYYY-MM-DD'),
                page: this.pagination.currentPage
              };
              if (this.filters.setoresSelecionados) {
                params.sectorId = this.filters.setoresSelecionados;
              }
              if (this.filters.categoriasSelecionadas) {
                params.category = this.filters.categoriasSelecionadas;
              }
              _context4.n = 2;
              return _application.applicationService.fetchApplicationsByDateRange(this.farm.id, params);
            case 2:
              _yield$applicationSer4 = _context4.v;
              response = _yield$applicationSer4.data;
              // Verificar se a resposta tem a estrutura {data: {data: [], meta: {}}} ou {data: [], meta: {}}
              responseData = response.data ? Array.isArray(response.data) ? response.data : response.data.data || [] : [];
              newApplications = this.transformApplicationData(responseData);
              if (reset) {
                this.applications = newApplications;
                this.filteredApplications = _toConsumableArray(newApplications);
              } else {
                (_this$applications = this.applications).push.apply(_this$applications, _toConsumableArray(newApplications));
                this.filteredApplications = _toConsumableArray(this.applications);
              }
              meta = response.meta || ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.meta) || {};
              this.pagination.totalCount = meta.total || 0;
              this.pagination.hasMore = meta.page < meta.lastPage;
              if (reset) {
                this.updateChartData();
                this.isLoadingFiltered = false;
              }
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              console.error('Erro ao carregar aplicações:', _t3);
              if (reset) {
                this.applications = [];
                this.filteredApplications = [];
              }
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function loadApplications() {
        return _loadApplications.apply(this, arguments);
      }
      return loadApplications;
    }(),
    transformApplicationData: function transformApplicationData(apiData) {
      var _this2 = this;
      if (!Array.isArray(apiData)) {
        console.warn('transformApplicationData: apiData is not an array:', apiData);
        return [];
      }
      return apiData.map(function (app) {
        var _app$prescription, _app$prescription2, _app$sector, _app$lot, _app$user, _app$user2, _app$prescription3, _app$prescription3$pr, _app$prescription4, _app$prescription5, _app$prescription6, _app$prescription7, _app$sector2, _app$equipment;
        return {
          id: app.id,
          nome: ((_app$prescription = app.prescription) === null || _app$prescription === void 0 ? void 0 : _app$prescription.name) || 'Sem nome',
          categoria: _this2.getCategoryLabel((_app$prescription2 = app.prescription) === null || _app$prescription2 === void 0 ? void 0 : _app$prescription2.category),
          setor: ((_app$sector = app.sector) === null || _app$sector === void 0 ? void 0 : _app$sector.name) || 'Sem setor',
          lote: ((_app$lot = app.lot) === null || _app$lot === void 0 ? void 0 : _app$lot.name) || null,
          dataAplicacao: app.applicationDate,
          description: app.description,
          observation: app.observation,
          status: app.status,
          user: "".concat(((_app$user = app.user) === null || _app$user === void 0 ? void 0 : _app$user.firstName) || '', " ").concat(((_app$user2 = app.user) === null || _app$user2 === void 0 ? void 0 : _app$user2.lastName) || '').trim(),
          produtos: ((_app$prescription3 = app.prescription) === null || _app$prescription3 === void 0 ? void 0 : (_app$prescription3$pr = _app$prescription3.productsDosage) === null || _app$prescription3$pr === void 0 ? void 0 : _app$prescription3$pr.map(function (p) {
            return p.productName;
          })) || [],
          tempoTrabalho: app.totalDuration ? _this2.formatDuration(app.totalDuration) : '--',
          periodoAplicacao: _this2.formatPeriodoAplicacao(app.returnDays),
          equipamento: app.equipment ? "".concat(app.equipment.name, " (").concat(app.equipment.type, ")") : '--',
          prescricaoCategoria: _this2.getCategoryLabel((_app$prescription4 = app.prescription) === null || _app$prescription4 === void 0 ? void 0 : _app$prescription4.category),
          prescricaoDescricao: ((_app$prescription5 = app.prescription) === null || _app$prescription5 === void 0 ? void 0 : _app$prescription5.description) || null,
          prescricaoProductsDosage: ((_app$prescription6 = app.prescription) === null || _app$prescription6 === void 0 ? void 0 : _app$prescription6.productsDosage) || [],
          prescricaoId: (_app$prescription7 = app.prescription) === null || _app$prescription7 === void 0 ? void 0 : _app$prescription7.id,
          setorId: (_app$sector2 = app.sector) === null || _app$sector2 === void 0 ? void 0 : _app$sector2.id,
          equipamentoId: (_app$equipment = app.equipment) === null || _app$equipment === void 0 ? void 0 : _app$equipment.id,
          returnDays: app.returnDays
        };
      });
    },
    getCategoryLabel: function getCategoryLabel(category) {
      var categoryMap = {
        'ADJUVANT': 'Adjuvante',
        'FERTILIZER': 'Fertilizante',
        'OIL': 'Óleo',
        'FUNGICIDE': 'Fungicida',
        'INSECTICIDE': 'Inseticida',
        'HERBICIDE': 'Herbicida',
        'FUNGICIDE_INSECTICIDE': 'Fungicida e Inseticida'
      };
      return categoryMap[category] || category;
    },
    applyFilters: function () {
      var _applyFilters = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.loadApplications(true);
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function applyFilters() {
        return _applyFilters.apply(this, arguments);
      }
      return applyFilters;
    }(),
    loadMore: function () {
      var _loadMore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(this.pagination.loading || !this.pagination.hasMore)) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              this.pagination.loading = true;
              this.pagination.currentPage++;
              _context6.n = 2;
              return this.loadApplications(false);
            case 2:
              this.pagination.loading = false;
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function loadMore() {
        return _loadMore.apply(this, arguments);
      }
      return loadMore;
    }(),
    onScroll: function onScroll(event) {
      var target = event.target;
      var threshold = 50;
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - threshold) {
        this.loadMore();
      }
    },
    updateChartData: function updateChartData() {
      var grouping = this.getChartGrouping();
      var _this$generateChartDa = this.generateChartData(grouping),
        labels = _this$generateChartDa.labels,
        data = _this$generateChartDa.data;
      this.chartData = {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: grouping === 'day' ? 'rgba(50, 115, 220, 0.1)' : '#3273dc',
          borderColor: '#3273dc',
          borderWidth: grouping === 'day' ? 2 : 1,
          fill: grouping === 'day',
          tension: grouping === 'day' ? 0.4 : 0
        }]
      };
      this.chartOptions = _objectSpread(_objectSpread({}, this.chartOptions), {}, {
        title: {
          display: true,
          text: "Aplica\xE7\xF5es ".concat(this.getChartTitle(grouping))
        },
        scales: _objectSpread(_objectSpread({}, this.chartOptions.scales), {}, {
          xAxes: [{
            ticks: {
              maxTicksLimit: grouping === 'day' ? 10 : 12
            }
          }]
        })
      });
    },
    getChartGrouping: function getChartGrouping() {
      var diffDays = (0, _moment.default)(this.filters.endDate).diff((0, _moment.default)(this.filters.startDate), 'days');
      if (diffDays <= 31) return 'day';
      if (diffDays <= 365) return 'month';
      return 'year';
    },
    generateChartData: function generateChartData(grouping) {
      var dataMap = new Map();
      this.filteredApplications.forEach(function (app) {
        var date = (0, _moment.default)(app.dataAplicacao);
        var key, label;
        switch (grouping) {
          case 'day':
            key = date.format('YYYY-MM-DD');
            label = date.format('DD/MM');
            break;
          case 'month':
            key = date.format('YYYY-MM');
            label = date.format('MMM/YY');
            break;
          case 'year':
            key = date.format('YYYY');
            label = date.format('YYYY');
            break;
        }
        console.log('label: ', label);
        dataMap.set(key, (dataMap.get(key) || 0) + 1);
      });
      var sortedEntries = Array.from(dataMap.entries()).sort(function (_ref, _ref2) {
        var _ref3 = _slicedToArray(_ref, 1),
          a = _ref3[0];
        var _ref4 = _slicedToArray(_ref2, 1),
          b = _ref4[0];
        return a.localeCompare(b);
      });
      return {
        labels: sortedEntries.map(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 1),
            key = _ref6[0];
          var date = (0, _moment.default)(key);
          switch (grouping) {
            case 'day':
              return date.format('DD/MM');
            case 'month':
              return date.format('MMM/YY');
            case 'year':
              return date.format('YYYY');
          }
        }),
        data: sortedEntries.map(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
            count = _ref8[1];
          return count;
        })
      };
    },
    getChartTitle: function getChartTitle(grouping) {
      var start = (0, _moment.default)(this.filters.startDate).format('DD/MM/YYYY');
      var end = (0, _moment.default)(this.filters.endDate).format('DD/MM/YYYY');
      var groupingText = {
        day: 'por Dia',
        month: 'por Mês',
        year: 'por Ano'
      }[grouping];
      return "".concat(groupingText, " (").concat(start, " - ").concat(end, ")");
    },
    formatDate: function formatDate(date) {
      return (0, _moment.default)(date).format('DD/MM/YYYY');
    },
    applyQuickFilter: function applyQuickFilter() {
      var now = (0, _moment.default)();
      switch (this.filters.quickFilter) {
        case '7d':
          this.filters.startDate = now.clone().subtract(7, 'days').startOf('day').toDate();
          this.filters.endDate = now.clone().endOf('day').toDate();
          break;
        case '30d':
          this.filters.startDate = now.clone().subtract(30, 'days').startOf('day').toDate();
          this.filters.endDate = now.clone().endOf('day').toDate();
          break;
        case '3m':
          this.filters.startDate = now.clone().subtract(3, 'months').startOf('day').toDate();
          this.filters.endDate = now.clone().endOf('day').toDate();
          break;
        case '1y':
          this.filters.startDate = now.clone().subtract(1, 'year').startOf('day').toDate();
          this.filters.endDate = now.clone().endOf('day').toDate();
          break;
        case 'custom':
          return;
      }
      this.applyFilters();
    },
    getStatusLabel: function getStatusLabel(status, applicationDate) {
      if (status === 'PENDING' && applicationDate) {
        var today = (0, _moment.default)().startOf('day');
        var appDate = (0, _moment.default)(applicationDate).startOf('day');
        if (appDate.isBefore(today)) {
          return 'Atrasada';
        }
      }
      var statusMap = {
        'PENDING': 'Pendente',
        'IN_PROGRESS': 'Em Andamento',
        'PAUSED': 'Pausado',
        'FINISHED': 'Finalizada',
        'CANCELLED': 'Cancelada'
      };
      return statusMap[status] || status;
    },
    getStatusClass: function getStatusClass(status, applicationDate) {
      if (status === 'PENDING' && applicationDate) {
        var today = (0, _moment.default)().startOf('day');
        var appDate = (0, _moment.default)(applicationDate).startOf('day');
        if (appDate.isBefore(today)) {
          return 'is-danger';
        }
      }
      var statusClasses = {
        'PENDING': 'is-warning',
        'IN_PROGRESS': 'is-info',
        'PAUSED': 'is-warning',
        'FINISHED': 'is-success',
        'CANCELLED': 'is-danger'
      };
      return statusClasses[status] || 'is-light';
    },
    openApplicationModal: function openApplicationModal(application) {
      this.selectedApplication = application;
      this.showApplicationModal = true;
    },
    formatDuration: function formatDuration(seconds) {
      if (!seconds || seconds === 0) return '--';
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor(seconds % 3600 / 60);
      return "".concat(hours, "h:").concat(minutes.toString().padStart(2, '0'), "min");
    },
    formatPeriodoAplicacao: function formatPeriodoAplicacao(returnDays) {
      if (returnDays === null || returnDays === undefined) return '--';
      return returnDays > 0 ? 'Recorrente' : 'Único';
    },
    startApplication: function () {
      var _startApplication = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(application) {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.showApplicationModal = false;
              _context7.n = 1;
              return this.updateApplicationStatus(application, 'IN_PROGRESS');
            case 1:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function startApplication(_x) {
        return _startApplication.apply(this, arguments);
      }
      return startApplication;
    }(),
    openStatusUpdateModal: function openStatusUpdateModal(application) {
      this.$buefy.modal.open({
        parent: this,
        component: {
          template: "\n            <div class=\"modal-card\">\n              <header class=\"modal-card-head\">\n                <p class=\"modal-card-title\">Atualizar Status</p>\n                <button class=\"delete\" @click=\"$parent.close()\"></button>\n              </header>\n              <section class=\"modal-card-body\">\n                <b-field label=\"Novo Status\">\n                  <b-select v-model=\"selectedStatus\" expanded>\n                    <option value=\"PAUSED\">Pausar</option>\n                    <option value=\"FINISHED\">Finalizar</option>\n                  </b-select>\n                </b-field>\n                \n                <div v-if=\"selectedStatus === 'FINISHED'\">\n                  <b-field label=\"Observa\xE7\xE3o\">\n                    <b-input v-model=\"observation\" type=\"textarea\" placeholder=\"Adicione observa\xE7\xF5es sobre a aplica\xE7\xE3o...\"></b-input>\n                  </b-field>\n                  \n                  <b-field label=\"Dias para retorno\">\n                    <b-input v-model=\"returnDays\" type=\"number\" min=\"0\" placeholder=\"Ex: 30\" :disabled=\"isUnicaAplicacao\"></b-input>\n                  </b-field>\n                  \n                  <b-field>\n                    <b-checkbox v-model=\"isUnicaAplicacao\" @input=\"onUnicaAplicacaoChange\">\n                      \xDAnica aplica\xE7\xE3o\n                    </b-checkbox>\n                  </b-field>\n                </div>\n              </section>\n              <footer class=\"modal-card-foot\">\n                <b-button @click=\"$parent.close()\">Cancelar</b-button>\n                <b-button type=\"is-primary\" @click=\"updateStatus\">Atualizar</b-button>\n              </footer>\n            </div>\n          ",
          data: function data() {
            return {
              selectedStatus: 'PAUSED',
              returnDays: '',
              isUnicaAplicacao: false,
              observation: '',
              application: application
            };
          },
          methods: {
            onUnicaAplicacaoChange: function onUnicaAplicacaoChange(value) {
              if (value) {
                this.returnDays = '0';
              } else {
                this.returnDays = '';
              }
            },
            updateStatus: function updateStatus() {
              var returnDaysValue = null;
              if (this.selectedStatus === 'FINISHED') {
                returnDaysValue = this.isUnicaAplicacao ? 0 : parseInt(this.returnDays) || null;
              }
              var observationValue = this.selectedStatus === 'FINISHED' ? this.observation : null;
              this.$parent.close();
              this.$parent.$parent.showApplicationModal = false;
              this.$parent.$parent.updateApplicationStatus(application, this.selectedStatus, returnDaysValue, observationValue);
            }
          }
        },
        hasModalCard: true
      });
    },
    resumeApplication: function resumeApplication(application) {
      this.showApplicationModal = false;
      this.updateApplicationStatus(application, 'IN_PROGRESS');
    },
    updateApplicationStatus: function () {
      var _updateApplicationStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(application, newStatus) {
        var returnDays,
          observation,
          data,
          statusMessages,
          _args8 = arguments,
          _t4;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              returnDays = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : null;
              observation = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : null;
              _context8.p = 1;
              data = {
                farmId: this.farm.id,
                status: newStatus
              };
              if (newStatus === 'FINISHED') {
                if (returnDays !== null) {
                  data.returnDays = returnDays;
                }
                if (observation) {
                  data.observation = observation;
                }
              }
              _context8.n = 2;
              return _application.applicationService.updateApplication(application.id, data);
            case 2:
              if (!(newStatus === 'FINISHED' && returnDays > 0)) {
                _context8.n = 3;
                break;
              }
              _context8.n = 3;
              return this.createReturnApplication(application, returnDays);
            case 3:
              _context8.n = 4;
              return this.loadApplications(true);
            case 4:
              _context8.n = 5;
              return this.loadDashboardData();
            case 5:
              statusMessages = {
                'IN_PROGRESS': 'Aplicação iniciada com sucesso',
                'PAUSED': 'Aplicação pausada com sucesso',
                'FINISHED': 'Aplicação finalizada com sucesso'
              };
              this.$buefy.toast.open({
                message: statusMessages[newStatus] || 'Status atualizado com sucesso',
                type: 'is-success'
              });
              _context8.n = 7;
              break;
            case 6:
              _context8.p = 6;
              _t4 = _context8.v;
              console.error('Erro ao atualizar status:', _t4);
              this.$buefy.toast.open({
                message: 'Erro ao atualizar status da aplicação',
                type: 'is-danger'
              });
            case 7:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 6]]);
      }));
      function updateApplicationStatus(_x2, _x3) {
        return _updateApplicationStatus.apply(this, arguments);
      }
      return updateApplicationStatus;
    }(),
    createReturnApplication: function () {
      var _createReturnApplication = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(originalApplication, returnDays) {
        var _appData$prescription, _appData$sector, _appData$equipment, newApplicationDate, _yield$applicationSer5, response, responseData, fullApp, appData, prescriptionId, sectorId, equipmentId, data, _error$response, _error$response$data, _t5;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              newApplicationDate = (0, _moment.default)().add(returnDays, 'days').format('YYYY-MM-DD'); // Buscar dados completos da aplicação se necessário
              _context9.n = 1;
              return _application.applicationService.fetchApplicationsByDateRange(this.farm.id, {
                startDate: (0, _moment.default)(originalApplication.dataAplicacao).format('YYYY-MM-DD'),
                endDate: (0, _moment.default)(originalApplication.dataAplicacao).format('YYYY-MM-DD')
              });
            case 1:
              _yield$applicationSer5 = _context9.v;
              response = _yield$applicationSer5.data;
              responseData = response.data ? Array.isArray(response.data) ? response.data : response.data.data || [] : [];
              fullApp = responseData.find(function (app) {
                return app.id === originalApplication.id;
              });
              appData = fullApp || originalApplication;
              prescriptionId = ((_appData$prescription = appData.prescription) === null || _appData$prescription === void 0 ? void 0 : _appData$prescription.id) || originalApplication.prescricaoId;
              sectorId = ((_appData$sector = appData.sector) === null || _appData$sector === void 0 ? void 0 : _appData$sector.id) || originalApplication.setorId;
              equipmentId = ((_appData$equipment = appData.equipment) === null || _appData$equipment === void 0 ? void 0 : _appData$equipment.id) || originalApplication.equipamentoId;
              if (!(!prescriptionId || !sectorId)) {
                _context9.n = 2;
                break;
              }
              throw new Error('Dados insuficientes para criar aplicação de retorno: prescrição e setor são obrigatórios');
            case 2:
              data = {
                farmId: this.farm.id,
                prescriptionId: prescriptionId,
                sectorIds: [sectorId],
                equipmentId: equipmentId || null,
                userId: this.user.id,
                status: 'PENDING',
                applicationDate: newApplicationDate,
                description: appData.description || originalApplication.description || 'Aplicação de retorno'
              };
              _context9.n = 3;
              return _application.applicationService.createApplication(data);
            case 3:
              this.$buefy.toast.open({
                message: "Nova aplica\xE7\xE3o agendada para ".concat((0, _moment.default)().add(returnDays, 'days').format('DD/MM/YYYY')),
                type: 'is-info'
              });
              _context9.n = 5;
              break;
            case 4:
              _context9.p = 4;
              _t5 = _context9.v;
              console.error('Erro ao criar aplicação de retorno:', _t5);
              this.$buefy.toast.open({
                message: "Erro ao criar aplica\xE7\xE3o de retorno: ".concat(((_error$response = _t5.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) || _t5.message),
                type: 'is-warning'
              });
            case 5:
              return _context9.a(2);
          }
        }, _callee9, this, [[0, 4]]);
      }));
      function createReturnApplication(_x4, _x5) {
        return _createReturnApplication.apply(this, arguments);
      }
      return createReturnApplication;
    }(),
    transformApplicationForModal: function transformApplicationForModal(application) {
      if (!application) return null;
      return {
        id: application.id,
        prescricao: application.nome,
        prescricaoCategoria: application.categoria,
        prescricaoDescricao: application.prescricaoDescricao,
        prescricaoProductsDosage: application.prescricaoProductsDosage || [],
        status: application.status,
        dataAplicacao: application.dataAplicacao,
        periodoAplicacao: application.periodoAplicacao,
        local: application.lote ? "".concat(application.lote, " - ").concat(application.setor) : application.setor,
        aplicador: application.user || '--',
        equipamento: application.equipamento || '--',
        tempoTrabalho: application.tempoTrabalho || '--',
        description: application.description,
        observation: application.observation,
        returnDays: application.returnDays,
        isRecurrent: application.isRecurrent
      };
    }
  }
};